import React from "react"
import Cabecalho from "../Cabecalho"
import { EnderecosBloqueadosForm } from "./components/EnderecosBloqueadosForm"

export function EnderecosBloqueados() {
    return (
        <>
            <Cabecalho pagina="Endereços Bloqueados" />
            <EnderecosBloqueadosForm />
        </>
    )
}
